import { CONTENT_API_PATH } from 'constants/api';
import { ApiService } from 'service/api/apiService';
import { FetchResult } from 'type/apiType';
import { ShortsListItem } from '../types/shortsType';

class ShortsService {
  constructor(private apiService: ApiService<ShortsListItem>) {}

  /**
   * Fetch Shorts list with minimal fields for list page.
   *
   * Filters content_type='shorts' on backend; mirrors movieService.fetchList pattern.
   */
  async fetchList(query: URLSearchParams): Promise<FetchResult<ShortsListItem>> {
    query.set('content_type', 'shorts');
    // BEE-5023: subtype 탭 분기를 위해 shorts_meta nested 도 같이.
    const fields = [
      'id', 'slug', 'status', 'i18n_title', 'title', 'title_en',
      'thumbnails', 'shorts_meta',
    ].join(',');
    query.set('fields', fields);
    return await this.apiService.fetch(query);
  }
}

export const shortsService = new ShortsService(
  new ApiService<ShortsListItem>(CONTENT_API_PATH)
);
